(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('.mega-show-more');
  if (!button) return;
  event.preventDefault();
  const grid = button.closest('.menu-link')?.querySelector('.sub-children-menu');
  if (!grid) return;
  const open = grid.classList.toggle('show-all-open');
  button.setAttribute('aria-expanded', open ? 'true' : 'false');
  button.querySelector('.label-more').hidden = open;
  button.querySelector('.label-less').hidden = !open;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    
class ProductInfoTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('.product-info-tabs__tab');
    this.panels = this.querySelectorAll('.product-info-tabs__panel');
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.index));
      tab.addEventListener('keydown', (e) => this.handleKey(e, tab));
    });
  }

  activate(index) {
    this.tabs.forEach((t) => {
      const isActive = t.dataset.index === index;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    this.panels.forEach((p) => {
      const isActive = p.dataset.index === index;
      p.classList.toggle('is-active', isActive);
      if (isActive) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });
  }

  handleKey(e, current) {
    const tabs = Array.from(this.tabs);
    const i = tabs.indexOf(current);
    let next = i;
    if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
    else return;
    e.preventDefault();
    tabs[next].focus();
    this.activate(tabs[next].dataset.index);
  }
}

if (!customElements.get('product-info-tabs')) {
  customElements.define('product-info-tabs', ProductInfoTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-jump-to"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.product-jump-to__chip').forEach((chip) => {
  chip.addEventListener('click', () => {
    const key = chip.dataset.tabKey;
    const tabsRoot = document.querySelector('product-info-tabs');
    if (key && tabsRoot) {
      const tab = tabsRoot.querySelector('[role="tab"][data-key="' + key + '"]');
      if (tab) tab.click();
    }
    chip
      .closest('.product-jump-to__list')
      .querySelectorAll('.product-jump-to__chip')
      .forEach((c) => c.classList.toggle('is-active', c === chip));
  });
});

  } catch(e) { console.error(e); }
})();
})();
